import { owlReportMetricsWeb } from '@RootCommon/utils/owl'
import { LastHeartBeatInfo, SystemResourceInfo } from './type'
import { getHornConfig } from '@RootCommon/utils/horn'
import { getClientType } from '@RootCommon/utils'
import { loganLog } from '@RootCommon/utils/logan'
import { leopardReport } from '../../leopardReport'

export enum HeartbeatErrorCode {
  success = 0,
  bad_network = 10001,
  weak_network = 10002,
  system_busy = 10003,
  om_closed = 10004,
  system_slept = 10005,
  unknown = 20000,
}

export const OFFLINE_GAP_TIME = 5 * 60 * 1000

/**
 * 心跳间隔上报
 */
export function reportHeartBeatGutter (gutter: number) {
  let gutterLevel = 0
  if (gutter < 30 * 1000) {
    // 30s内
    gutterLevel = 1
  } else if (gutter < 60 * 1000) {
    // 1min内
    gutterLevel = 2
  } else if (gutter < 180 * 1000) {
    // 5min内
    gutterLevel = 3
  } else {
    // 超出5min
    gutterLevel = 4
  }
  owlReportMetricsWeb({ heart_beat_gutter: 1 }, { gutterLevel })
}
